import { ApiConfig } from '@/config/api.config';
import type { IntegrationMessageKind } from './integration-message.types';

export const getIntegrationMessageApiConfig = (kind: IntegrationMessageKind) => {
    return ApiConfig.queries.superAdmin.integrationMessages[kind];
};

export const getIntegrationMessageBasePath = (kind: IntegrationMessageKind) => {
    switch (kind) {
        case 'inbox':
            return '/superAdmin/data/inbox';
        case 'outbox':
            return '/superAdmin/data/outbox';
        case 'internalOutbox':
            return '/superAdmin/data/internal-outbox';
        case 'emailOutbox':
            return '/superAdmin/data/email-outbox';
    }
};

export const getIntegrationMessageTypesForKind = (
    kind: IntegrationMessageKind,
    types?: {
        inboxTypes: string[];
        outboxTypes: string[];
        internalOutboxTypes: string[];
        emailOutboxTypes: string[];
    },
) => {
    if (!types) return [];
    switch (kind) {
        case 'inbox':
            return types.inboxTypes;
        case 'outbox':
            return types.outboxTypes;
        case 'internalOutbox':
            return types.internalOutboxTypes;
        case 'emailOutbox':
            return types.emailOutboxTypes;
    }
};

export const hasAggregateFields = (kind: IntegrationMessageKind) =>
    kind === 'inbox' || kind === 'outbox';

export const hasExternalIdField = (kind: IntegrationMessageKind) => kind === 'inbox';

export const hasTenantField = (kind: IntegrationMessageKind) =>
    kind === 'inbox' || kind === 'outbox' || kind === 'internalOutbox';

export const hasTryCountField = (kind: IntegrationMessageKind) =>
    kind === 'internalOutbox' || kind === 'emailOutbox';
